import {
    FETCH_ALIGNMENT_SCORE_START,
    FETCH_ALIGNMENT_SCORE_SUCCESS,
    FETCH_ALIGNMENT_SCORE_FAIL

} from "../../../constants";
import {
    FETCH_BENCHMARK_ALIGNMENT_SCORE_URL,

} from "../../../../../config/constants";
import { createVisualizationFetchAction } from "./createVisualizationFetchAction";

export const getBenchmarkAlignmentScore = createVisualizationFetchAction(FETCH_BENCHMARK_ALIGNMENT_SCORE_URL, {
    START: FETCH_ALIGNMENT_SCORE_START,
    SUCCESS: FETCH_ALIGNMENT_SCORE_SUCCESS,
    FAIL: FETCH_ALIGNMENT_SCORE_FAIL,
});
